// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2017":"3e64d867","6215":"3e64d867","6379":"6d0c9276","7433":"3e64d867"}[chunkId] + ".chunk.css";
};